const LILIANA_SETTINGS = 'LILIANA_SETTINGS';

export function getById(id) {
  return document.getElementById(id);
}
export function getByClass(className) {
  return document.getElementsByClassName(className)[0];
}
/**
 * VD: num = parseFloat("42.318")+100
 * kết quả sẽ ra là num = 142.31799999999998, chứ ko phải 142.318
 * do đó cần convert num thành số có 3 chữ số sau dấu phẩy (3 decimal places)
 **/
export function myParseFloat(num) {
  return parseFloat(num.toFixed(3));
}

/**
 * Convert time stamp to seconds
 * @param {string} timestamp Lyrics time stamp, in format [2:17.88] or [1:03:45.32]
 * @return {number} Time in seconds, float number
 * Reference: https://github.com/guoyunhe/rabbit-lyrics/blob/master/src/index.js
 */
export function decodeTime(timestamp) {
  if (!timestamp || typeof timestamp !== 'string') return 0;
  let results;

  // [hh:mm:ss.xx] format, used by some long audio books
  results = timestamp.match(/\[(\d+):(\d+):(\d+\.\d+)\]/);
  if (results && results.length === 4) {
    return parseFloat((parseInt(results[1]) * 60 * 60 + parseInt(results[2]) * 60 + parseFloat(results[3])).toFixed(3));
  }

  // [mm:ss.xx] format, widely used for songs
  // chú ý: regex này có 2 group: (\d+) và (\d+\.\d+)
  // do đó results sẽ là 1 mảng chứa 2 group này
  results = timestamp.match(/\[(\d+):(\d+\.\d+)\]/);
  if (results && results.length === 3) {
    return parseFloat((parseInt(results[1]) * 60 + parseFloat(results[2])).toFixed(3));
  }

  return 0;
}

/**
 * create and return new element
 * @param {string} tagName type of tag to create (ex: div, span, h1...)
 * @param {string} id id of tag
 * @param {string} classList list of classes for this tag
 * @param {JSON} attributes list of attribute this tag
 * @return {HTMLElement} element that be created
 **/
export function createNewElement(tagName, id, classList, attributes = null) {
  let ele = document.createElement(tagName);

  if (id && typeof id === 'string') {
    ele.setAttribute('id', id);
  }
  if (classList && typeof classList === 'string') {
    ele.setAttribute('class', classList);
  }
  if (attributes && typeof attributes === 'object') {
    for (let i = 0; i < Object.keys(attributes).length; i++) {
      ele.setAttribute(Object.keys(attributes)[i], attributes[Object.keys(attributes)[i]]);
    }
  }

  return ele;
}

/**
 * save setting to local storage
 */
export function saveSetting(key, value) {
  let settings;
  if (localStorage && localStorage.getItem(LILIANA_SETTINGS)) {
    settings = JSON.parse(localStorage.getItem(LILIANA_SETTINGS));
    settings[key] = value;
  } else {
    settings = {
      [key]: value
    };
  }
  localStorage.setItem('LILIANA_SETTINGS', JSON.stringify(settings));
}

/**
 * get setting from local storage
 */
export function getSetting(key) {
  if (localStorage && localStorage.getItem(LILIANA_SETTINGS)) {
    let settings = JSON.parse(localStorage.getItem(LILIANA_SETTINGS));
    return settings[key];
  }
  return null;
}

/**
 * Filter table
 * @param {string} tableId ID of table
 * @param {integer} column The position of column we want to filter table on (first column = 0)
 * @param {string} searchText Text for filtering
 */
export function filterTable(tableId, column, searchText) {
  var filter, table, tr, td, i, txtValue;
  filter = searchText.toUpperCase();
  table = document.getElementById(tableId);
  tr = table.getElementsByTagName('tr');
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName('td')[column];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = '';
      } else {
        tr[i].style.display = 'none';
      }
    }
  }
}

export function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }

  return array;
}

export const getAbsoluteUrl = (uri) => {
  if (uri.startsWith('http')) return uri;
  return process.env.REACT_APP_HOST_API + uri;
};

/**
 * Check if a date is valid
 * @param {Date} d date to check
 * @returns {boolean}
 */
export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

/**
 * Format date: m/yyyy. Ref: https://stackoverflow.com/a/34015511/7688028
 * @param {Date} d date to format
 * @returns {string}
 */
export const formatDateMY = (d) => {
  const options = { year: 'numeric', month: 'numeric' };
  return d.toLocaleDateString('vi-VN', options);
};

/**
 * Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 */
export function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
}

/**
 * Ref: Copilot.
 * Note: we must have an image with id="spinning_img" and a canvas with id="spinning_canvas" in the HTML,
 * they can be hidden. And the image must have crossOrigin="anonymous" attribute, otherwise we will get a
 * SecurityError when trying to access the image data: https://stackoverflow.com/a/27840082/7688028
 */
export function getAverageRGB(brightnessFactor = 1.6) {
  const img = document.getElementById('spinning_img');
  const canvas = document.getElementById('spinning_canvas');

  // Multiple readback operations using getImageData are faster with the willReadFrequently attribute set to true
  const ctx = canvas.getContext('2d', { willReadFrequently: true });

  // Set canvas dimensions to match the image
  canvas.width = img.width;
  canvas.height = img.height;

  // Draw the image onto the canvas
  ctx.drawImage(img, 0, 0, img.width, img.height);

  // Get image data
  const imageData = ctx.getImageData(0, 0, img.width, img.height);
  const data = imageData.data;

  let r = 0,
    g = 0,
    b = 0;
  const pixelCount = img.width * img.height;

  // Iterate through each pixel
  for (let i = 0; i < data.length; i += 4) {
    r += data[i]; // Red
    g += data[i + 1]; // Green
    b += data[i + 2]; // Blue
  }

  // Calculate average color
  r = Math.floor(r / pixelCount);
  g = Math.floor(g / pixelCount);
  b = Math.floor(b / pixelCount);

  // Increase brightness
  r = Math.min(255, Math.floor(r * brightnessFactor));
  g = Math.min(255, Math.floor(g * brightnessFactor));
  b = Math.min(255, Math.floor(b * brightnessFactor));

  return `rgb(${r}, ${g}, ${b})`;
}
